export default "__VITE_ASSET__CH3p$zH0__"